var React = require('react');

function ChevronUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.43734 8L6.74054 3.69593L11.0437 8L12.8926 6.15117L6.74054 0L0.588504 6.15117L2.43734 8Z","fill":"#555555"}));
}

ChevronUpInline.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ChevronUpInline;

ChevronUpInline.default = ChevronUpInline;
